import React from 'react';

import Header from '../components/Header'
import Footer from '../components/Footer'
import DocContent from '../components/DocContent'
import MainNavigation from '../components/MainNavigation'

export default (props) => (
    <div>
        <Header></Header>
        <MainNavigation></MainNavigation>
        <DocContent></DocContent>
        <Footer></Footer>
    </div>
)
